////// BOTON AÑADIR CESTA //////
document.querySelectorAll('.buttonAdd').forEach(r =>
  r.addEventListener('click', e => {
    document.querySelectorAll('.sizesContainer').forEach(({ style }) => (style.display = 'none'));
    e.target.parentElement.querySelector('.sizesContainer').style.display = 'block';
    setTimeout(() => {
      e.target.parentElement.querySelector('.sizesContainer').style.display = 'none';
    }, 4500);

    e.target.parentElement.querySelectorAll('.sizesContainer .add-to-cart-item').forEach(e => {
      const vari = JSON.parse(e.getAttribute('data-option'));
      e.addEventListener('click', () => {
        const { available, id } = vari;

        if (available) {
          const body = {
            items: [
              {
                quantity: 1,
                id
              }
            ]
          };

          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
          }).then(() => {
            const cartDotDOM = document.querySelector('.Header__CartDot');
            cartDotDOM.classList.add('is-visible');
            const toast = document.querySelector('.toast');
            const dotCart = document.querySelector('.Header__CartDot');
            toast.classList.add('is-active');

            const temp1 = {
              bubbles: true,
              detail: {
                variant: vari,
                quantity: 1
              }
            };
            document.dispatchEvent(new CustomEvent('product:added', temp1));
            setTimeout(() => {
              toast.classList.remove('is-active');
            }, 4500);
          });
        }
      });
    });
  })
);

document.querySelectorAll('.sizesContainer .add-to-cart-item').forEach(e => {
  const vari = JSON.parse(e.getAttribute('data-option'));
  e.addEventListener('click', () => {
    const { available, id } = vari;

    if (available) {
      const body = {
        items: [
          {
            quantity: 1,
            id
          }
        ]
      };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
      }).then(() => {
        const cartDotDOM = document.querySelector('.Header__CartDot');
        cartDotDOM.classList.add('is-visible');
        const toast = document.querySelector('.toast');
        const dotCart = document.querySelector('.Header__CartDot');
        toast.classList.add('is-active');

        const temp1 = {
          bubbles: true,
          detail: {
            variant: vari,
            quantity: 1
          }
        };
        document.dispatchEvent(new CustomEvent('product:added', temp1));
        setTimeout(() => {
          toast.classList.remove('is-active');
        }, 4500);
      });
    }
  });
});




///////////////
document.querySelectorAll('.img-open').forEach( r =>
  r.addEventListener('click', e=> {
    console.log("click  ")
    const imgZoom = document.querySelector('.img-zoom')
    const img = imgZoom.querySelector('.img-zz')

    img.src = e.target.dataset.url
    imgZoom.style.display= 'block'


    ////// Zoom Img ////////
    imgZoom.addEventListener('mousemove', (e) => { 
      e.preventDefault()
      const {height, width} = imgZoom.getBoundingClientRect()
      const ypercent = e.offsetY/height
      const xpercent = e.offsetX / width
      const himg = img.getBoundingClientRect().height
      const wimg = img.getBoundingClientRect().width
      img.style.transform = `translateY(${-1 * (himg - height)* ypercent}px)`
    })
    
    //////zoom img movile ////
   
    imgZoom.addEventListener('click', e=> {
      img.src = ''
      imgZoom.style.display = 'none'
      })
    })
    
  )
  

